<template>
	<div class="app-container">
		<el-form :model="form" ref="form" size="small">
		  <el-form-item label="证书类型:">
		    {{ form.certTypeName }}
      </el-form-item>
      <el-form-item label="创建时间:">
        {{ form.createTime }}
      </el-form-item>
			<el-form-item label="颁证时间:">
        {{ form.issueTime }}
			</el-form-item>
			<el-form-item label="颁证单位:">
        {{ form.issueUnit }}
			</el-form-item>
			<el-form-item label="证书编号:">
        {{ form.certNo }}
			</el-form-item>
			<el-form-item label="查询官网:">
        {{ form.checkWebsite }}
			</el-form-item>
			<el-form-item label="颁给人/单位:">
        {{ form.certTo }}
			</el-form-item>
			<el-form-item label="角膜塑形镜验配师id:">
        {{ form.jmsxjypsId }}
			</el-form-item>
			<el-form-item label="会员id:">
        {{ form.hyId }}
			</el-form-item>
			<el-form-item label="颁证内容:">
        {{ form.issueContent }}
      </el-form-item>
			<el-form-item label="会员单位主营分类:">
        {{ form.hydwType }}
			</el-form-item>
			<el-form-item label="会员单位地址:">
        {{ form.hydwAddress }}
      </el-form-item>
			<el-form-item label="会员单位所属行业:">
        {{ form.hydwTrade }}
			</el-form-item>
			<el-form-item label="会员单位企业类型:">
        {{ form.hydwEnterpriseType }}
      </el-form-item>
			<el-form-item label="会员单位注册资本:">
        {{ form.hydwRegisteredCapital }}
			</el-form-item>
			<el-form-item label="会员单位经营模式:">
        {{ form.hydwBusinessModel }}
			</el-form-item>
			<el-form-item label="会员单位注册地址:">
        {{ form.hydwRegisteredAddress }}
			</el-form-item>
			<el-form-item label="会员单位成立时间:">
        {{ form.hydwEstablished }}
			</el-form-item>
			<el-form-item label="会员单位主营产品或服务:">
				{{ form.hydwMainProductsServices }}
			</el-form-item>
			<el-form-item label="会员单位主要采购产品:">
				{{ form.hydwMainPurchasedProducts }}
			</el-form-item>
		</el-form>
	</div>
</template>

<script>


export default {
	name: 'Zhengshu',
	data() {
		return {
			// 表单参数
			form: {},

		};
	},
	created() {
		this.certInfo();
	},
	methods: {

		reset() {
		},
		certInfo() {
	        const id = this.$decrypt(this.$route.query.id);
	        console.log('若依自带的方法',id);
        	this.req({
        	    url: '/system/cert/' + id,
            	params: {},
            	method: 'get'
        	}).then(res => {
        		this.form = res.data;
        	});
        }
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/zhengshu.vue